import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import PaidIcon from "@mui/icons-material/Paid";
import { useGetCustomerSummaryMutation } from "../../redux/reducer/features/Customer/CustomerSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { Dispatch } from "@reduxjs/toolkit";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import { addCustomerDashboardCounts } from "../../redux/reducer/features/Dashboard/DashboardSlice";
export const CustomerDashboard: React.FunctionComponent = () => {
  const customerId = useSelector(
    (state: AppState) => state.authReducer.customerData?.customerId
  );
  const dealerId = useSelector(
    (state: AppState) => state.authReducer?.dmsDealerId
  );
  const customerDashboardStats = useSelector(
    (state: AppState) => state.dashboardReducer.customerDashboard
  );
  const dispatch = useDispatch<Dispatch<any>>();
  const [customerSummaryMutation, customerSummaryMutationresult] =
    useGetCustomerSummaryMutation();

  React.useEffect(() => {
    if (customerDashboardStats === undefined)
      customerSummaryMutation({
        customerId: customerId?.toString() ?? "",
        dealerId: dealerId ?? "",
      });
  }, []);

  React.useEffect(() => {
    if (
      customerSummaryMutationresult.data &&
      customerSummaryMutationresult.isSuccess
    ) {
      if (customerSummaryMutationresult.data.status === 200) {
        if (customerSummaryMutationresult.data.entityList.length > 0) {
          let values =
            customerSummaryMutationresult.data.entityList[0].invoiceSummary.filter(
              (item: any) => item.period === "LifeTime"
            );

          dispatch(
            addCustomerDashboardCounts({
              customerDashboard: {
                totalEquipments:
                  customerSummaryMutationresult.data.entityList[0]
                    .customerOwnedEquipment.length,
                service: values[0].service,
                parts: values[0].parts,
                equipments: values[0].equipment,
              },
            })
          );
        }
      }
    }
  }, [customerSummaryMutationresult]);
  return (
    <Grid container spacing={3}>
      <Grid item lg={3} sm={6} xl={3} xs={12}>
        <Card sx={{ height: "100%" }}>
          <CardContent>
            <Grid
              container
              spacing={3}
              sx={{ justifyContent: "space-between" }}
            >
              <Grid item>
                <Typography
                  color="textSecondary"
                  gutterBottom
                  variant="overline"
                >
                  Total Equipments
                </Typography>
                <Typography color="textPrimary" variant="h5">
                  {customerSummaryMutationresult.isLoading ? (
                    <CircularProgress size="1.2rem" color="inherit" />
                  ) : (
                    customerDashboardStats?.totalEquipments?.toLocaleString() ??
                    0
                  )}
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  sx={{
                    backgroundColor: "error.main",
                    height: 56,
                    width: 56,
                  }}
                >
                  <PrecisionManufacturingIcon />
                </Avatar>
              </Grid>
            </Grid>

            <Box
              sx={{
                pt: 2,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography color="textSecondary" variant="caption">
                LifeTime Span Purchasing
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              spacing={3}
              sx={{ justifyContent: "space-between" }}
            >
              <Grid item>
                <Typography
                  color="textSecondary"
                  gutterBottom
                  variant="overline"
                >
                  SPENT ON SERVICE
                </Typography>
                <Typography color="textPrimary" variant="h5">
                  {customerSummaryMutationresult.isLoading ? (
                    <CircularProgress size="1.2rem" color="inherit" />
                  ) : (
                    customerDashboardStats?.service?.toLocaleString() ?? 0
                  )}
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  sx={{
                    backgroundColor: "success.main",
                    height: 56,
                    width: 56,
                  }}
                >
                  <PaidIcon />
                </Avatar>
              </Grid>
            </Grid>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                pt: 2,
              }}
            >
              <Typography color="textSecondary" variant="caption">
                LifeTime Span Purchasing
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              spacing={3}
              sx={{ justifyContent: "space-between" }}
            >
              <Grid item>
                <Typography
                  color="textSecondary"
                  gutterBottom
                  variant="overline"
                >
                  SPENT ON PARTS
                </Typography>
                <Typography color="textPrimary" variant="h5">
                  {customerSummaryMutationresult.isLoading ? (
                    <CircularProgress size="1.2rem" color="inherit" />
                  ) : (
                    customerDashboardStats?.parts?.toLocaleString() ?? 0
                  )}{" "}
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  sx={{
                    backgroundColor: "success.main",
                    height: 56,
                    width: 56,
                  }}
                >
                  <PaidIcon />
                </Avatar>
              </Grid>
            </Grid>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                pt: 2,
              }}
            >
              <Typography color="textSecondary" variant="caption">
                LifeTime Span Purchasing
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              spacing={3}
              sx={{ justifyContent: "space-between" }}
            >
              <Grid item>
                <Typography
                  color="textSecondary"
                  gutterBottom
                  variant="overline"
                >
                  SPENT ON EQUIPMENTS
                </Typography>
                <Typography color="textPrimary" variant="h5">
                  {customerSummaryMutationresult.isLoading ? (
                    <CircularProgress size="1.2rem" color="inherit" />
                  ) : (
                    customerDashboardStats?.equipments?.toLocaleString() ?? 0
                  )}{" "}
                </Typography>
              </Grid>
              <Grid item>
                <Avatar
                  sx={{
                    backgroundColor: "success.main",
                    height: 56,
                    width: 56,
                  }}
                >
                  <PaidIcon />
                </Avatar>
              </Grid>
            </Grid>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                pt: 2,
              }}
            >
              <Typography color="textSecondary" variant="caption">
                LifeTime Span Purchasing
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
